import { type ColumnDef, createColumnHelper, DataTable } from "@aurumiq/ui/composite/data-table";
import { dmyTime, relativeTime } from "@aurumiq/ui/lib/format";
import { Link } from "react-router";
import type { CrashGroup } from "@/lib/types";

const col = createColumnHelper<CrashGroup>();

const columns = [
  col.accessor("message", {
    header: "Message",
    cell: (c) => (
      <div>
        <div className="line-clamp-2 max-w-lg font-mono text-xs">{c.getValue()}</div>
        <div className="font-mono text-[11px] text-muted-foreground">
          {c.row.original.group_hash.slice(0, 12)}
        </div>
      </div>
    ),
  }),
  col.accessor("count", { header: "Count", meta: { numeric: true } }),
  col.accessor("orgs", {
    header: "Organisations",
    enableSorting: false,
    cell: (c) => (
      <span className="flex flex-wrap gap-1.5">
        {c.getValue().map((o) => (
          <Link
            key={o.id}
            to={`/orgs/${o.id}/telemetry`}
            className="rounded-full border px-2 py-0.5 text-primary text-xs hover:underline"
            title={o.name}
          >
            {o.code}
          </Link>
        ))}
        {c.getValue().length === 0 ? <span className="text-muted-foreground">—</span> : null}
      </span>
    ),
  }),
  col.accessor("last_seen_at", {
    header: "Last seen",
    cell: (c) => <span title={dmyTime(c.getValue())}>{relativeTime(c.getValue())}</span>,
  }),
] as ColumnDef<CrashGroup, unknown>[];

export function CrashGroupsTable({ groups }: { groups: CrashGroup[] }) {
  return (
    <DataTable
      columns={columns}
      data={groups}
      getRowId={(g) => g.group_hash}
      emptyMessage="No crashes in this period."
    />
  );
}
